export type UserInfo = {
  vehicleType: 'car' | 'moto';
  plateNumber: string;
  creditCardNumber: string;
  creditCardExp: string;
};

class UserEditStore {
  #key = 'is_edited';

  reset = () => {
    localStorage.removeItem(this.#key);
  };

  edit = () => {
    localStorage.setItem(this.#key, '1');
  };

  get isEdit() {
    return localStorage.getItem(this.#key) ?? false;
  }
}

export const userEditStore = new UserEditStore();
